import OnlineOrderSetting from "@online-order-setting/OnlineOrderSetting.tsx";
import {memo} from "react";

const OnlineOrderSettingView = () => {
  return(
    <OnlineOrderSetting/>
  )
}

export default memo(OnlineOrderSettingView)